import { RESERVATION_TIMER_CONSTANTS } from '../constants/reservation-timer.constants';
import { CAPTCHA_TYPE } from '../constants/widget-constants';
import { CaptchaPartnerSettings, CaptchaUserState, AdyenPaymentBookGate } from '../models/adyen-payment-booking.model';

/**
 * Whether a host may book on its own once Adyen reported a payment that no Book press is waiting
 * for - paid on the hosted page, or inside Drop-in itself (its own pay button, or Enter in a card
 * field) - exactly what a Book press would do now. Anything that would stop that press (an incomplete form, an unsolved
 * captcha, an expired reservation, a disabled button, a booking already on its way) means no:
 * the shopper sees the payment as done, completes what is missing and presses Book. A booking
 * already on its way is also what keeps this from sending a second /book.
 */
export function canBookAfterAdyenPayment(gate: AdyenPaymentBookGate): boolean {
  return gate.paymentHeld
    && !gate.bookingBlocked
    && !gate.reservationExpired
    && !gate.formIncomplete
    && !gate.captchaPending;
}

/** The partner requires a captcha (either kind) that the shopper has not solved. */
export function isCaptchaChallengePending(
  partner: CaptchaPartnerSettings | null | undefined,
  userState: CaptchaUserState | null | undefined,
): boolean {
  if (Number(partner?.is_captcha_feature_enabled) !== 1) {
    return false;
  }
  if (partner?.captcha_type === CAPTCHA_TYPE.CALENSO_DEFAULT) {
    return !userState?.captcha_challenge;
  }
  if (partner?.captcha_type === CAPTCHA_TYPE.FRIENDLY) {
    return !userState?.friendly_captcha_challenge;
  }

  return false;
}

/**
 * The message for an expired reservation. With a payment held for the booking the plain "go back
 * and pick a new slot" would leave the shopper not knowing what happens to their money - and going
 * back drops the payment - so it says that nothing was booked and the payment is refunded.
 */
export function reservationExpiredMessageKey(paymentHeld: boolean): string {
  return paymentHeld
    ? RESERVATION_TIMER_CONSTANTS.MESSAGE_KEYS.PAYMENT_REFUNDED
    : RESERVATION_TIMER_CONSTANTS.MESSAGE_KEYS.BOOKING_BLOCKED;
}
